import React from "react";
import { Route, useRouteMatch } from "react-router-dom";

import PageOperations from "../pages/operations";

const RouteOperations = () => {
  const { path } = useRouteMatch();

  return (
    <Route exact path={path}>
      <PageOperations />
    </Route>
  );
};

export default RouteOperations;
